import { gridClasses } from "@mui/x-data-grid";

export const DATA_GRID_HEIGHT = "650px";

export const dataGridStyles = {
  flex: 1,
  border: "none",
  [`& .${gridClasses.columnHeader}, & .${gridClasses.cell}`]: {
    outline: "transparent",
  },
  [`& .${gridClasses.columnHeader}`]: {
    backgroundColor: "#f5f6fa",
    outline: "transparent",
    fontWeight: 600,
  },
  [`& .${gridClasses.columnHeader}:focus-within, & .${gridClasses.cell}:focus-within`]:
    {
      outline: "none",
    },
  [`& .${gridClasses.row}:hover`]: {
    cursor: "pointer",
    backgroundColor: "#fafafa",
  },
  "& .row-disabled": {
    opacity: 0.5,
    pointerEvents: "none",
  },
};
